import { render, staticRenderFns } from "./ProductMoneySupplier.vue?vue&type=template&id=632179ff&scoped=true&"
import script from "./ProductMoneySupplier.vue?vue&type=script&lang=js&"
export * from "./ProductMoneySupplier.vue?vue&type=script&lang=js&"
import style0 from "./ProductMoneySupplier.vue?vue&type=style&index=0&id=632179ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632179ff",
  null
  
)

export default component.exports